import clsx from "clsx";
import { startCase } from "lodash";
import type { FC, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

import { useDropdownQuickAdd } from "@ryde/redux";
import { onActivateKeyDown, SINGLE_KEY, type RydeUiUnit } from "@ryde/shared";

import { NoOptionWrapper } from "./dropdown-bound.styled";
import { useCanQuickAddStation } from "./dropdowns-bound-quick-add/quick-add-station/use-can-quick-add-station";

interface IDropdownBoundNoOptionsProps {
  name: string;
  dropItemsSource?: RydeUiUnit;
  closeDropdown: () => void;
}

export const DropdownBoundNoOptions: FC<IDropdownBoundNoOptionsProps> = ({
  name,
  dropItemsSource,
  closeDropdown,
}) => {
  const { t } = useTranslation();

  const { isQuickAddOpen, suffixToEntity, openQuickAdd } = useDropdownQuickAdd({
    entity: dropItemsSource,
    name,
  });

  const canQuickAdd = useCanQuickAddStation({
    name,
    dropItemsSource,
    suffixToEntity,
  });

  const handleQuickAddClick = (e: SyntheticEvent): void => {
    e.stopPropagation();
    closeDropdown();
    openQuickAdd();
  };

  return (
    <NoOptionWrapper className={clsx({ hidden: !isQuickAddOpen })}>
      <div>{t("errors.noOptionsMessage")}</div>

      {canQuickAdd && (
        <span
          onClick={handleQuickAddClick}
          onKeyDown={onActivateKeyDown(handleQuickAddClick)}
          role="button"
          tabIndex={0}
          className="no-options-create-link"
        >
          {startCase(
            t("general.ADD_NEW", {
              entity: t(`${dropItemsSource}.${SINGLE_KEY}`),
            }),
          )}
        </span>
      )}
    </NoOptionWrapper>
  );
};
